import React from "react";

const StatusRow = ({
  title,
  value,
  isLives,
  padding,
  margin,
  borderSize,
  portrait,
  backgroundColor,
}) => (
  <div
    className={`flex items-center justify-between gap-2 bg-transparent transition-colors duration-500 p-${padding || "2.5"} mb-${margin || "2.5"}`}
  >
    <div className="text-white text-2xl">{title}</div>
    {isLives ? (
      <div className="flex gap-1">
        {Array.from({ length: value }).map((_, index) => (
          <span key={index} className="text-red-500 text-2xl">❤️</span>
        ))}
      </div>
    ) : (
      <div className="text-white text-2xl ml-1">{value}</div>
    )}
  </div>
);

StatusRow.defaultProps = {
  isLives: false,
};

export default StatusRow;